import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-29" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-30" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-31" data-mp="vuh863qwaqh9">
          <div className="inline-flex rounded-full bg-brand-sage/20 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-sageInk" data-id="element-32" data-mp="qtt8yusij3by">
            INCLUS
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-slate md:text-4xl" data-id="element-33" data-mp="14rhu83qhschj">🎁 5 Bonus Exclusifs</h2>
          <p className="mt-4 text-brand-gray" data-id="element-34" data-mp="zsn92v51ybu9">
            Valeur <span className="font-bold text-brand-terracottaInk line-through" data-id="element-35" data-mp="1ei2ml9fkoks0">91 €</span> — inclus aujourd&apos;hui
            sans coût supplémentaire.
          </p>
        </div>
        <div className="space-y-3" data-id="element-36" data-mp="1njakhqe6fjlk">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-slate/[0.06] bg-white p-4 shadow-sm sm:gap-5" data-id="element-37" data-mp="1jiqmylpoydyw" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-slate font-serif font-bold text-white" data-id="element-38" data-mp="3trx770csjhcw">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Couverture de ${bonus.title}`} loading="lazy" className="h-20 w-20 shrink-0 rounded-md border border-brand-sand bg-brand-sandSoft object-cover shadow-sm sm:h-24 sm:w-24" data-id="element-39" data-mp="7kp9mk844erf" />
              <div className="min-w-0 flex-1" data-id="element-40" data-mp="gj0yagpf52h8">
                <h3 className="font-bold leading-snug text-brand-slate" data-id="element-41" data-mp="ld57l6m5pmlh">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-42" data-mp="qbgg9e0ptr24">
                  <span className="text-brand-gray" data-id="element-43" data-mp="qdb0sr82rh5o">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-terracottaInk line-through" data-id="element-44" data-mp="vbuoox68b30o">
                    valeur {bonus.price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-sageInk" data-id="element-45" data-mp="akpf8akxwpe0">OFFERT</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}